
export let BASE_URL = "";
export const CURRENT_ENV = "UAT"; // DEV, UAT, PREPROD, PROD

if (CURRENT_ENV === "DEV") {
  BASE_URL = "https://devapi.vylorseedresearch.com/rest/";
}

if (CURRENT_ENV === "UAT") {
  BASE_URL = "https://uatapi.vylorseedresearch.com/rest/";
}

if (CURRENT_ENV === "PREPROD") {
  BASE_URL = "https://prodapi.vylorseedresearch.com/rest/";
}

if (CURRENT_ENV === "PROD") {
  BASE_URL = "https://api.vylorseedresearch.com/rest/";
}


export const NOSSOLOGIN = BASE_URL + "mcrc/validateUserIDANDPassword";//old login API
export const LOGIN = BASE_URL + "mcrc/portalLogin";
export const notifications = BASE_URL + "mcrc/Login/notifications";
export const forgetPassword = BASE_URL + "mcrc/Login/forgetPassword";

//Base64
// export const getFileByPath = `${BASE_URL}mcrc/getFileByPath`;
// export const getFileByPath = BASE_URL + "mcrc/getFileByPath";
export const getFileByPath = BASE_URL + "mcrc/api/media";
//RoleMAster
export const addRoleMaster = BASE_URL + "mcrc/addRoleMaster";
export const getRoleMaster = BASE_URL + "mcrc/getRoleMaster";
// export const DownloadCsHistory = BASE_URL + "mcrc/centralStore/acceptor/downloadCentralStoreHistoryReports";
export const DownloadCsHistory = BASE_URL + "mcrc/centralStore/acceptor/downloadCentralStoreHistoryReports_v1";
// export const StockInWardExcelUpload = BASE_URL + "mcrc/centralStore/acceptor/stockInWardExcelUpload";
export const StockInWardExcelUpload = BASE_URL + "mcrc/centralStore/acceptor/stockInWardExcelUpload_v1";
// export const StockInWardExcelFileFormat = BASE_URL + "mcrc/centralStore/acceptor/stockInWardExcelFileFormat";
export const StockInWardExcelFileFormat = BASE_URL + "mcrc/centralStore/acceptor/stockInWardExcelFileFormat_v1";

//UserMaster
// export const getUserMaster = BASE_URL + "mcrc/getUserMaster";
export const getUserMaster = BASE_URL + "mcrc/getUserMaster_v1";
export const getManagerBasedOnCostCenter =
  BASE_URL + "mcrc/getManagerBasedOnCostCenter";
export const getFunctionalLeadBasedOnCostCenter =
  BASE_URL + "mcrc/getFunctionalLeadBasedOnCostCenter";
export const getCostCenterBasedOnFunctionalLead =
  BASE_URL + "mcrc/getCostCenterBasedOnFunctionalLead";
export const getEmployeeBasedOnManager =
  BASE_URL + "mcrc/getEmployeeBasedOnManager";
export const addUserMaster = BASE_URL + "mcrc/addUserMaster";
export const getUserSupportedMasters =
  BASE_URL + "mcrc/getUserSupportedMasters";
export const getUserTypeMaster = BASE_URL + "mcrc/getUserTypeMaster";
export const resetPassword = BASE_URL + "mcrc/resetPassword";

//MainStoreMaster
export const getMainStoreMaster = BASE_URL + "mcrc/getMainStoreMaster";
export const addMainStoreMaster = BASE_URL + "mcrc/addMainStoreMaster";

//Ui Master
export const addUnitMeasureMaster = BASE_URL + "mcrc/addUIMMaster";
export const getUnitMeasureMaster = BASE_URL + "mcrc/getUIMMaster";

//StoreMaster
export const getStoreMaster = BASE_URL + "mcrc/getStoreMaster";
export const addStoreMaster = BASE_URL + "mcrc/addStoreMaster";

//RackMaster
export const getRackMaster = BASE_URL + "mcrc/getRackMaster";
export const addRackMaster = BASE_URL + "mcrc/addRackMaster";

//Stock-InWard
export const getMasters = BASE_URL + "mcrc/centralStore/requester/getMasters";
// export const openStock = BASE_URL + "mcrc/centralStore/acceptor/openStock";
export const openStock = BASE_URL + "mcrc/centralStore/acceptor/openStock_v1";

export const stockInWardSubmit =
  BASE_URL + "mcrc/centralStore/acceptor/stockInWardSubmit";

//getRecieved Returns
export const getAllRecievedRequests =
  BASE_URL + "mcrc/centralStore/acceptor/getAllRecievedRequests";
export const getAllRecievedReturns =
  BASE_URL + "mcrc/centralStore/acceptor/getAllRecievedReturns";
export const submitRecievedReturns =
  BASE_URL + "mcrc/centralStore/acceptor/submitRecievedReturns";
export const productStatus =
  BASE_URL + "mcrc/centralStore/acceptor/productStatus";
export const openStockDetails =
  BASE_URL + "mcrc/centralStore/acceptor/openStockDetails";

//CorePermit

export const getDayWisePermitCountMethodCorePermit =
  BASE_URL + "mcrc/rmTracking/getDayWisePermitCount";

export const getAssembleLocation =
  BASE_URL + "mcrc/rmTracking/getAssembleLocations";
export const saveCorePermitForm =
  BASE_URL + "mcrc/rmTracking/saveCorePermitForm";
export const getCorePermitFormByNumber = (mobile) => {
  return `${BASE_URL}mcrc/rmTracking/getCorePermitForms?mobileNumber=${mobile}`;
};
//AssetMaster
export const getAssets = BASE_URL + "mcrc/getAssets";
export const addAsset = BASE_URL + "mcrc/addAsset";

export const getMainAssets = BASE_URL + "mcrc/getMainAssets";
export const addMainAsset = BASE_URL + "mcrc/addMainAsset";
export const addProduct = BASE_URL + "mcrc/addProduct";
export const getProducts = BASE_URL + "mcrc/getProducts";
export const getCategory = BASE_URL + "mcrc/getCategoryMaster";
export const addSubAsset = BASE_URL + "mcrc/addSubAsset";
export const getSubAssets = BASE_URL + "mcrc/getSubAssets";
export const addCategoryMaster = BASE_URL + "mcrc/addCategoryMaster";
export const submitRecievedRequests =
  BASE_URL + "mcrc/centralStore/acceptor/submitRecievedRequests";
export const getroleAssetMapping = BASE_URL + "mcrc/getroleAssetMapping";
export const setroleAssetMapping = BASE_URL + "mcrc/setroleAssetMapping";
export const history = BASE_URL + "mcrc/centralStore/acceptor/history";
export const getCorePermits = BASE_URL + "mcrc/rmTracking/getCorePermits";
export const saveVendorDetails = BASE_URL + "mcrc/rmTracking/saveVendorDetails";

// export const TransferCorePermit =
//   BASE_URL + "mcrc/rmTracking/transferCorePermit";

export const TransferCorePermit =
  BASE_URL + "mcrc/rmTracking/vendorTransferCorePermit";

// Acceptor Transfer Permit

export const AcceptorTransferCorePermit =
  BASE_URL + "mcrc/rmTracking/acceptor/acceptorTransferCorePermit";

export const PermitExtension =
  BASE_URL + "mcrc/rmTracking/permitExtension";


//Critical Elevated WOrk

export const saveAdditionalPermit =
  BASE_URL + "mcrc/rmTracking/saveAdditionalPermit";

export const transferCorePermit =
  BASE_URL + "mcrc/rmTracking/transferCorePermit";

export const ApproveRejectPermit =
  BASE_URL + "mcrc/rmTracking/ApproveRejectPermit";
export const getAllPermitsByCorePermitID =
  BASE_URL + "mcrc/rmTracking/getAllPermitsByCorePermitID";
// export const bulkUploadExcelFileFomat =
//   BASE_URL + "mcrc/rmTracking/technician/bulkUploadExcelFileFomat";

export const bulkUploadExcelFileFomat =
  BASE_URL + "mcrc/rmTracking/technician/bulkUploadExcelFileFomat_v1";

// export const uploadBulkWork =
//   BASE_URL + "mcrc/rmTracking/technician/uploadBulkWork";

export const uploadBulkWork =
  BASE_URL + "mcrc/rmTracking/technician/uploadBulkWork_v1";

export const getUploadedExcelFileDetails =
  BASE_URL + "mcrc/rmTracking/technician/getUploadedExcelFileDetails";

export const getAllSubmittedPermits =
  BASE_URL + "mcrc/rmTracking/getAllSubmittedPermits";

export const rmComplaintsAcceptReject =
  BASE_URL + "mcrc/rmTracking/acceptor/rmComplaintsAcceptReject";

// export const rmComplaints = BASE_URL + "mcrc/rmTracking/acceptor/rmComplaints";
export const rmComplaints = BASE_URL + "mcrc/rmTracking/acceptor/rmComplaints_v1";

export const rmGetmasters = BASE_URL + "mcrc/rmTracking/getMasters";

export const newRqeuestAcceptReject =
  BASE_URL + "mcrc/rmTracking/acceptor/newRqeuestAcceptReject";

export const newRqeuest = BASE_URL + "mcrc/rmTracking/acceptor/newRqeuest";

export const dailyWorkLogView =
  BASE_URL + "mcrc/rmTracking/acceptor/dailyWorkLogView";
export const dailyWorkLogViewById =
  BASE_URL + "mcrc/rmTracking/acceptor/dailyWorkLogViewById";

export const dailyWorkLogAssignedToMe =
  BASE_URL + "mcrc/rmTracking/acceptor/dailyWorkLogAssignedToMe";

export const dailyWorkLogUpdateWork =
  BASE_URL + "mcrc/rmTracking/acceptor/dailyWorkLogUpdateWork";

export const equipmentMonitorAssignedList =
  BASE_URL + "mcrc/rmTracking/acceptor/equipmentMonitorAssignedList";
// export const Rmhistory = BASE_URL + "mcrc/rmTracking/acceptor/history";
export const Rmhistory = BASE_URL + "mcrc/rmTracking/acceptor/history_v1";
export const getAllPermits = BASE_URL + "mcrc/rmTracking/getAllPermits";

// export const RmhistoryGet = BASE_URL + "mcrc/farmOperations/acceptor/rmHistory";
export const RmhistoryGet = BASE_URL + "mcrc/farmOperations/acceptor/rmHistory_v1";
export const FarmOperation_getMasters =
  BASE_URL + "mcrc/farmOperations/getMasters";
export const rmActivity = BASE_URL + "mcrc/farmOperations/acceptor/rmActivity ";
export const getAllRecievedRequestsFarmOperation =
  BASE_URL + "mcrc/farmOperations/acceptor/getAllRecievedRequests";
export const requestAcceptReject =
  BASE_URL + "mcrc/farmOperations/acceptor/requestAcceptReject";
export const getAllRecievedRequestsForUpdateActivity =
  BASE_URL +
  "mcrc/farmOperations/acceptor/getAllRecievedRequestsForUpdateActivity";
export const FarmOperationsgetMasters =
  BASE_URL + "mcrc/farmOperations/getMasters";
export const FarmOperationRMHistoryAll =
  BASE_URL + "mcrc/farmOperations/acceptor/getAllrmHistory";
export const FarmOperationAcceptHistory =
  BASE_URL + "mcrc/farmOperations/acceptor/acceptorHistory";
export const FarmOperationReOpenActivity =
  BASE_URL + "mcrc/farmOperations/acceptor/reOpenActivity";
export const deleteActivity =
  BASE_URL + "mcrc/farmOperations/acceptor/deleteActivity";
export const dashboardCountSummary =
  BASE_URL + "mcrc/Login/dashboardCountSummary";
//for CS Reports APIs
export const reportForStockInwardRequestReturn =
  BASE_URL + "mcrc/centralStore/acceptor/centralStoreReports";

//for R&M Reports APIs

export const reportForRMTracking =
  BASE_URL + "mcrc/rmTracking/rmTrackingReports";
export const UpdateActivitygGet = BASE_URL + "mcrc/farmOperations/acceptor/getCurrentActivityUpdate";
// export const DownloadRMAcceptorHistory = BASE_URL + "mcrc/rmTracking/acceptor/downloadRMAcceptorHistory"

export const DownloadRMAcceptorHistory = BASE_URL + "mcrc/rmTracking/acceptor/downloadRMAcceptorHistory_v1"

//R&M Peoples Dropdown For Job Site Inspector
export const GetAllAcceptorList = BASE_URL + "mcrc/rmTracking/getAllAcceptorList"

/////new dashboard apis

export const turnAroundAPI =
  BASE_URL + "mcrc/centralStore/requester/getTurnAroundTime";
export const RequestDeliverdCountAPI =
  BASE_URL + "mcrc/centralStore/requester/getRequestedandDeliveredCount";
export const CostAnalysisAPI =
  BASE_URL + "mcrc/centralStore/requester/getCostCenterAnalysis";
export const MonthlyRequestedDataAPI =
  BASE_URL + "mcrc/centralStore/requester/getRequestFilledWithMonth";

// Man power

export const getEmployeeMasterDetails =
  BASE_URL + "mcrc/manPower/getEmployeeMasterDetails";
export const saveEmployeeMaster = BASE_URL + "mcrc/manPower/saveEmployeeMaster";
export const getEmployeeMasterDetailsById =
  BASE_URL + "mcrc/manPower/getEmployeeMasterDetailsById";
export const getEmployeeDetailsBasedOnName =
  BASE_URL + "mcrc/getEmployeeDetailsBasedOnName";
export const getLegalEntities = BASE_URL + "mcrc/manPower/getLegalEntities";
export const changePassword = BASE_URL + "mcrc/changePassword";
export const workPermitsHistory =
  BASE_URL + "mcrc/rmTracking/workPermitsHistory";

//Analysis DashBoard
export const getTurnAroundTime = BASE_URL + "mcrc/rmTracking/getTurnAroundTime";
export const getRequestedandDeliveredCount =
  BASE_URL + "mcrc/rmTracking/getRequestedandDeliveredCount";
export const getRequestFilledWithMonth =
  BASE_URL + "mcrc/rmTracking/getRequestFilledWithMonth";
export const getCorePermitApprovedData =
  BASE_URL + "mcrc/rmTracking/getCorePermitApprovedData";
export const farmOperationgetTurnAroundTime =
  BASE_URL + "mcrc/farmOperations/getTurnAroundTime";
export const farmOperationGetRequestFullfill =
  BASE_URL + "mcrc/farmOperations/getRequestFilledWithMonth";
export const FarmOperationgetRequestedandDeliveredCount =
  BASE_URL + "mcrc/farmOperations/getRequestedandDeliveredCount";
export const getCurrentActivityUpdate =
  BASE_URL + "mcrc/farmOperations/getCurrentActivityUpdate";
export const getMainCropFunctionBasedOnEmployeeName =
  BASE_URL + "mcrc/getMainCropFunctionBasedOnEmployeeName";
export const getSubCropFunctionBasedOnEmployeeName =
  BASE_URL + "mcrc/getSubCropFunctionBasedOnEmployeeName";
export const getEquipmentBreakdownCount =
  BASE_URL + "mcrc/rmTracking/getEquipmentBreakdownCount";
export const sendCentralGridDataToMail = BASE_URL + "mcrc/centralStore/acceptor/sendCentralGridDataToMail";
export const DripMasterGet = BASE_URL + "masters/getDripSystemMasterListMaster";
export const DripMasterAdd = BASE_URL + "masters/updateDripSystemMaster";
export const DGMasterGet = BASE_URL + "masters/getDGDetailesMaster";
export const DGMasterAdd = BASE_URL + "masters/updateDGDetailesMaster ";
export const SprayerMasterGet = BASE_URL + "masters/getSprayersMaster";
export const SprayerMasterAdd = BASE_URL + "masters/updateSprayersMaster";
export const BorewellMasterGet = BASE_URL + "masters/getBorewellMaster";
export const BorewellMasterAdd = BASE_URL + "masters/updateBorewellMaster";
export const ImplementMasterGet = BASE_URL + "masters/getImplementsMaster ";
export const ImplementMasterAdd = BASE_URL + "masters/updateImplementMaster";
export const TractorMastereGet = BASE_URL + "masters/getTracerMaster";
export const TractorMasterAdd = BASE_URL + "masters/updateTractorMaster";
export const MainActivityMasterGet = BASE_URL + "masters/getMainActivityMaster";
export const MainActivityMasterAdd = BASE_URL + "masters/updateMainActivityMaster";
export const ActivityMasterGet = BASE_URL + "masters/getActivityList";
export const ActivityMasterAdd = BASE_URL + "masters/updateActivityMaster";
export const PloteLocationGet = BASE_URL + "masters/getPlotLocationMaster";
export const PloteLocationAdd = BASE_URL + "masters/updatePlotLocationMaster";
export const PlotAcrageMasterGet = BASE_URL + "masters/getPlotAcrageMaster";
export const PlotAcrageMasterAdd = BASE_URL + "masters/updatePlotAcrageMaster";
export const ChemicalMasterGet = BASE_URL + "masters/getChemicalMaster";
export const ChemicalMasterAdd = BASE_URL + "masters/updateChemicalMaster";
export const FertilizerMasterGet = BASE_URL + "masters/getFertilizerMaster";
export const FertilizerMasterAdd = BASE_URL + "masters/updateFertilizerMaster";
export const CropFunctionMasterGet = BASE_URL + "masters/getCropFunctionMaster";
export const CropFunctionMasterAdd = BASE_URL + "masters/updateCropFunctionMaster";
export const getCropMasterGet = BASE_URL + "masters/getCropMaster";
export const getCropMasterAdd = BASE_URL + "masters/updateCropMaster";
export const FunctionMasterGet = BASE_URL + "masters/getFunctionMaster";
export const FunctionMasterAdd = BASE_URL + "masters/updateFunctionMaster";
export const SubCropMasterGet = BASE_URL + "masters/getSubCropMaster";
export const SubCropMasterAdd = BASE_URL + "masters/updateSubCropMaster";
export const RMActivityMasterGet = BASE_URL + "masters/getRMActivityMaster";
export const RMActivityMasterAdd = BASE_URL + "masters/updateRMActivityMaster";
export const SubFunctionsMasterAdd = BASE_URL + "masters/updateSubFunctionMaster";
export const SubFunctionsMasterGet = BASE_URL + "masters/getSubFunctionMaster";
export const SiteMasterGet = BASE_URL + "masters/getSiteMaster";
export const SiteMasterAdd = BASE_URL + "masters/updateSiteMaster";
export const SubSiteMasterGet = BASE_URL + "masters/getSubSiteMaster";
export const SubSiteMasterAdd = BASE_URL + "masters/updateSubSiteMaster";
export const UomGetMaster = BASE_URL + "masters/getUOMMaster";
export const EquipmentMasterGet = BASE_URL + "masters/getEquipmentMaster";
export const EquipmentMasterAdd = BASE_URL + "masters/updateEquipmentMaster";
export const EquipmentLocationMasterGet = BASE_URL + "masters/getEquipmentLocationMaster";
export const EquipmentLocationMasterAdd = BASE_URL + "masters/updateEquipmentLocationMaster";
export const EquipmentSubLocationMasterGet = BASE_URL + "masters/getEquipmentSubLocationMaster";
export const EquipmentSubLocationMasterAdd = BASE_URL + "masters/updateEquipmentSubLocationMaster";
export const UserMenuControl = BASE_URL + "mcrc/getUserMenuControl";
export const UserMenuControlSubmit = BASE_URL + "mcrc/addUserMenuController";
export const getFileServerAuthenticationCode = BASE_URL + "mcrc/Login/getFileServerAuthenticationCode";
